import AppRoute from "models/AppRoute"
import { Guid } from "@/types"

interface IPrepareShippingRouteParams {
    shippingOrderId: Guid
}

interface IPrepareShippingRouteQuery {
    backUrl?: string
}

const PrepareShippingRoute = new AppRoute<IPrepareShippingRouteParams, IPrepareShippingRouteQuery>({
    route: "/prepare-shipping/:shippingOrderId",
    navbar: true,
    authRequired: true,
})

export default PrepareShippingRoute
